export class ProposalProjectAffectionDepartment{
    constructor(department, proposalProject, impactLevel){
        this.department = department;
        this.proposalProject = proposalProject;
        this.impactLevel = impactLevel;
    }
    static createFromResponseData(responseData){
        return new ProposalProjectAffectionDepartment(
            responseData.department,
            responseData.proposalProject,
            responseData.impactLevel
        );
    }
};